module.exports = __webpack_public_path__ + "static/img/8.aeb58fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/8.png
// module id = GJ38
// module chunks = 35